import { useEffect, useMemo } from 'react';

import { useParams } from 'react-router-dom';

import {
  useGetContestsListQuery,
  usePostContestEnterMutation,
} from '@/services/api.service';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { SET_CURRENT_CONTEST } from '@/store/slices/contest.slice';

import { ContestType } from '@/types/domain';

export const useContests = () => {
  const dispatch = useAppDispatch();
  const { id = '0' } = useParams();
  const {
    data: contests = [],
    isFetching,
    refetch,
  } = useGetContestsListQuery({ params: {} });
  const { contest } = useAppSelector((store) => store.contest);

  const currentContest = useMemo(
    () => contests.find((_: ContestType) => _.contest_id === Number(id)) || {},
    [contests, id],
  ) as ContestType;

  useEffect(() => {
    // Store last selected contest
    if (Object.keys(currentContest).length) {
      dispatch(SET_CURRENT_CONTEST(currentContest));
    }
  }, [currentContest, dispatch]);

  const [
    triggerPostEnter,
    {
      isLoading: isMakeSelectionsLoading,
      isSuccess: isMakeSelectionsSuccess,
      isError: isMakeSelectionsError,
    },
  ] = usePostContestEnterMutation();

  useEffect(() => {
    if (isMakeSelectionsSuccess) {
      refetch();
    }
  }, [isMakeSelectionsSuccess, refetch]);

  return {
    contests,
    currentContest: contest,
    isFetchingContests: isFetching,
    triggerPostEnter,
    isMakeSelectionsLoading,
    isMakeSelectionsSuccess,
    isMakeSelectionsError,
  };
};
